import { storeSettings } from 'repositories/redux/settings/store.settings'
import axios from '../../axios'
import { apiVer4 } from 'repositories/restfuls/apis/api.v4.x'

export function authLogin(email, password, role) {
  const cred = {
    email: email,
    password: password,
    role: role,
  }
  return async (dispatch) => {
    try {
      dispatch({ type: 'USER_LOGIN_PENDING' })
      const response = await axios.post('Endusers/login', cred)
      dispatch({
        type: 'USER_LOGIN_FULFILLED',
        payload: { ...response.data, role: role },
      })
    } catch (err) {
      console.log(err)
      if (err.response) {
        dispatch({
          type: 'USER_LOGIN_REJECTED',
          payload: {
            error: err.response.statusText,
            message: err.response.data,
            code: err.response.status,
          },
        })
      } else if (err) {
        dispatch({
          type: 'USER_LOGIN_REJECTED',
          payload: { error: '', message: 'Login Failed', code: err.status },
        })
      } else {
        dispatch({
          type: 'USER_LOGIN_REJECTED',
          payload: { error: '', message: 'Login Failed', code: err.status },
        })
      }
    }
  }
}
export function authLogout() {
  return async (dispatch) => {
    try {
      dispatch({ type: 'USER_LOGOUT_PENDING' })
      const response = await axios.post('Endusers/logout')
      dispatch({ type: 'USER_LOGOUT_FULFILLED', payload: response.data })
      dispatch({ type: 'CLEAR_STORE', payload: null })
      dispatch(storeSettings.actions.clrSettings())
      dispatch(apiVer4.util.resetApiState())
    } catch (err) {
      dispatch({ type: 'USER_LOGOUT_REJECTED', payload: err.message })
    }
  }
}
export function authReset() {
  return async (dispatch) => {
    try {
      dispatch({ type: 'USER_LOGOUT_PENDING' })
      dispatch({ type: 'USER_LOGOUT_FULFILLED' })
      dispatch({ type: 'CLEAR_STORE', payload: null })
    } catch (err) {
      dispatch({ type: 'USER_LOGOUT_REJECTED', payload: err.message })
    }
  }
}

export function authDismissAlert() {
  return {
    type: 'USER_LOGON_DISMISS',
    payload: false,
  }
}
export function authRestoreLogon(logon) {
  return {
    type: 'USER_LOGON_RESTORE',
    payload: logon,
  }
}
